export async function getEmailExceptions() {
    try {
        const response = await fetch(
            'https://5slmkmj750.execute-api.ap-southeast-1.amazonaws.com/prod/getEmailExceptions',
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data; // Return the fetched email exceptions
        } else {
            console.error(`Error: Failed to fetch email exceptions. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while fetching email exceptions.', error);
        return null;
    }
}


export async function getEmailExceptionsByClientId(clientId) {
  try {
    const response = await fetch(
      `https://5slmkmj750.execute-api.ap-southeast-1.amazonaws.com/prod/getEmailExceptions?clientId=${encodeURIComponent(clientId)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      console.error(`Error: Failed to fetch email exceptions. Status: ${response.status}`);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching email exceptions by clientId:", error);
    return null;
  }
}


export async function postEmailException(emailExceptionParameters = []) {

    const payloadArray = emailExceptionParameters;

    try {
        const response = await fetch(
            "https://88mgxfzyfl.execute-api.ap-southeast-1.amazonaws.com/prod/postEmailException",
            {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payloadArray),
            }
        );

        const json = await response.json();

        if (!response.ok) {
            console.error(
                `Error: Failed to post email-exception data. Status: ${response.status}`,
                json
            );
            return null;
        }
        return json;
    } catch (error) {
        console.error(
            "Error: Network or other error occurred while posting email-exception data.",
            error
        );
        return null;
    }
}

// export async function postEmailExceptionChanges(changes) {
//     const resp = await fetch(
//         "https://bcugjl2qz9.execute-api.ap-southeast-1.amazonaws.com/prod/postEmailExceptionChanges",
//         {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify(changes),
//         }
//     );

//     if (!resp.ok) {
//         const text = await resp.text();
//         throw new Error(`postEmailExceptionChanges failed (${resp.status}): ${text}`);
//     }

//     return resp.json();
// }

export async function postEmailExceptionChanges({ clientId, new: newList }) {
  const payload = { clientId, new: newList };

  const resp = await fetch(
    "https://bcugjl2qz9.execute-api.ap-southeast-1.amazonaws.com/prod/postEmailExceptionChanges",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`postEmailExceptionChanges failed (${resp.status}): ${text}`);
  }

  return resp.json();
}

